/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { useStoreZustandTecnologias } from "@/store-zustand/tecnologias";
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetTecnologias } from "@/domain/use-cases/tecnologias";

export type ITecnologias = {
  id: number;
  nome: string;
  descricao: string;
  ativo?: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: null;
};

export type ITecnologiasResponse = {
  code: number;
  status: string;
  message: string;
  data: ITecnologias[];
  pagination: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
};

const EMPTY_TECNOLOGIAS: ITecnologias[] = [];

type UseBuscarTecnologiasOptions = {
  somenteAtivos?: boolean;
};

function useBuscarTecnologias(options: UseBuscarTecnologiasOptions = {}) {
  const { somenteAtivos = false } = options;
  const { currentPage, itemsPerPage, searchItem } = useStoreZustandTecnologias();

  const { token: accessToken } = useStoreZustandUserAuth();

  // Chave de cache única baseada na página atual e na quantidade de itens por página
  const queryKey = ["tecnologias", currentPage, itemsPerPage, searchItem, somenteAtivos];

  const {
    error: isErrorProdutos,
    data: tecnologiasResponse,
    isLoading: isLoadingTecnologias,
  } = useQuery<ITecnologiasResponse>({
    queryKey,
    queryFn: async () => {
      const response = await handleGetTecnologias(
        accessToken!,
        currentPage,
        itemsPerPage,
        searchItem ?? "",
        somenteAtivos
      );

      return response;
    },
    //diz ao React Query: "enquanto os novos dados estão carregando, mantenha os dados antigos"
    placeholderData: (previousData) => previousData,
  });

  const tecnologias = tecnologiasResponse?.data ?? EMPTY_TECNOLOGIAS;

  return {
    tecnologias,
    isLoadingTecnologias,
    isErrorProdutos,
  };
}

/**
 * EXPORTS
 */
export { useBuscarTecnologias };
